// Message chime and incoming-call ringtone that respect the phone's ringer.
//
// In the apps, WebView audio ignores silent mode (iOS treats an <audio> ringtone
// as media playback; Android plays web audio on the media stream), so these
// sounds go through the native NotificationSound plugin
// (ios/App/App/NotificationSoundPlugin.swift,
// android/.../NotificationSoundPlugin.java):
//   Android  silent / Do Not Disturb: nothing; vibrate: vibration; normal: sound
//   iOS      sound is muted by the Ring/Silent switch; vibration follows settings
// The web has no ringer to read, so it keeps the in-page sounds.

import { Capacitor, registerPlugin } from '@capacitor/core';

const NotificationSound = registerPlugin('NotificationSound');

export const usesNativeNotificationSound = () => Capacitor.isNativePlatform();

/** sound: 'message' | 'ringtone'. Resolves { played: 'sound' | 'vibrate' | 'none' }. */
export const playNativeNotificationSound = (sound) =>
  NotificationSound.play({ sound }).catch((err) => {
    console.warn('[NotificationSound]', err);
    return { played: 'none' };
  });

export const stopNativeNotificationSound = () => NotificationSound.stop().catch(() => {});

/**
 * Android only. False when this applicationId has no google-services.json,
 * which makes PushNotifications.register() crash the process.
 * Missing method (older builds) is treated as configured so the main app
 * keeps registering.
 */
export const isAndroidFirebaseConfigured = async () => {
  if (Capacitor.getPlatform() !== 'android') return true;
  try {
    const res = await NotificationSound.isFirebaseConfigured();
    return res?.configured !== false;
  } catch {
    return true;
  }
};
